import { useContext } from 'react';
import ServiceRequestContext from '../referral/components/ServiceRequestProvider/context';

const useServiceRequestContext = () => {
  const serviceRequestContext = useContext(ServiceRequestContext);
  return serviceRequestContext;
};

export default useServiceRequestContext;
